import type { ChartHistoryFilterType } from "@roman/shared/constants/predictionChart";
import type { ChartDataPoint, Choice } from "@roman/shared/features/chart/types";
import { bucketChoiceProbabilitiesV2 } from "@roman/shared/features/chart/utils";
import type { PredictionMarketDetailsResponse } from "@roman/shared/hooks/PredictionMarket/useGetPredictionMarketDetails";

/**
 * チャートデータを生成する
 * 選択された期間（displayMode）に基づいて、確率の履歴データを適切な時間間隔でグループ化
 * 例: "1d"なら1時間ごと、"1w"なら6時間ごと、"all"なら日数に応じて自動調整
 */
export const getChartData = (
  predictionMarketDetails: PredictionMarketDetailsResponse | undefined,
  choices: Choice[],
  displayMode: ChartHistoryFilterType,
  marketEndTime: number | null | undefined,
): ChartDataPoint[] => {
  if (!predictionMarketDetails) return [];
  const choiceIds = choices.map((c) => c.id);
  return bucketChoiceProbabilitiesV2(
    predictionMarketDetails.predictionMarketHistory,
    choiceIds,
    displayMode,
    marketEndTime || Date.now(),
  );
};
